import { gql } from '@apollo/client';
import { CORE_POSITION_FIELDS } from '../fragments/position.fragment';

export const POSITIONS_QUERY = gql`
  ${CORE_POSITION_FIELDS}
  query GetPositions($limit: Int) {
    positions(limit: $limit) {
      ...CorePositionFields
    }
  }
`;

export default POSITIONS_QUERY;
